var Handlebars = require("handlebars/dist/handlebars");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"d-flex\">\r\n  <form class=\"print-view \" style=\"width:100%;\"></form>\r\n</div>\r\n<div class=\"error-view\"></div>";
},"useData":true});